import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LicenseBatchDto } from 'src/app/models/license.model';

export type DeviceLicenseBatchCardMode = 'linked' | 'available';

@Component({
  selector: 'app-device-license-batch-card',
  templateUrl: './device-license-batch-card.component.html',
  styleUrls: ['./device-license-batch-card.component.scss'],
  standalone: false,
})
export class DeviceLicenseBatchCardComponent {
  @Input({ required: true }) batch!: LicenseBatchDto;
  @Input({ required: true }) mode!: DeviceLicenseBatchCardMode;
  @Input() processing = false;

  @Output() openDetails = new EventEmitter<void>();
  @Output() changeLink = new EventEmitter<void>();

  get batchTitle(): string {
    return this.batch.name?.trim() || 'License Batch';
  }

  get productLabel(): string {
    return (
      this.batch.product?.name?.trim() ||
      this.batch.licensedProductId?.trim() ||
      'Not assigned'
    );
  }

  get scopeLabel(): string {
    return (
      this.batch.scope?.name?.trim() ||
      this.batch.scope?.id?.trim() ||
      'Not assigned'
    );
  }

  get linkActionLabel(): string {
    return this.mode === 'linked'
      ? 'Unlink license batch'
      : 'Link license batch';
  }

  get linkActionIcon(): string {
    return this.mode === 'linked' ? 'link_off' : 'link';
  }

  formatDate(dateString?: string): string {
    if (!dateString) {
      return 'Not set';
    }

    const parsedDate = new Date(dateString);
    if (isNaN(parsedDate.getTime())) {
      return dateString;
    }

    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
    }).format(parsedDate);
  }
}
